export enum ETreinoIds {
  APP_SETTINGS = 'app-treino-settings',
  ACTIVITIES_SETTINGS = 'activities-settings',
  EXERCISES = 'exercises',
  PREDEFINED_WORKOUTS = 'predefined-workouts',
  PREDEFINED_WORKOUT_SHEETS = 'predefined-workout-sheets',
  MUSCLE_GROUPS = 'muscle-groups',
  GRADUATIONS = 'graduations',
}

export const treinoPageFragments = [
  {
    id: ETreinoIds.APP_SETTINGS,
    title: 'SETTINGS.TREINO.APP_SETTINGS.TITLE',
  },
  {
    id: ETreinoIds.ACTIVITIES_SETTINGS,
    title: 'SETTINGS.TREINO.ACTIVITIES_SETTINGS.TITLE',
  },
  {
    id: ETreinoIds.EXERCISES,
    title: 'TREINO.EXERCISES.EXERCISES',
  },
  {
    id: ETreinoIds.PREDEFINED_WORKOUTS,
    title: 'TREINO.PREDEFINED_WORKOUTS.PREDEFINED_WORKOUTS',
  },
  {
    id: ETreinoIds.PREDEFINED_WORKOUT_SHEETS,
    title: 'TREINO.PREDEFINED_WORKOUT_SHEETS.PREDEFINED_WORKOUT_SHEETS',
  },
  {
    id: ETreinoIds.MUSCLE_GROUPS,
    title: 'SETTINGS.TREINO.MUSCLE_GROUPS.TITLE',
  },
  {
    id: ETreinoIds.GRADUATIONS,
    title: 'TREINO.GRADUATIONS.TITLE',
  },
];